<script>
/**
 * ****************************************************************************
 * @description     :   Zip code Component
 * @created at      :   2023/07/17
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   STworks
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import _ from 'lodash-uuid';

/**
 * Import template
 */
import template from './template.html';

/**
 * Define content of zip code component
 */
var AnsZipCode = {
    template: template,
    props: {
        id: String,
        label: String,
        itemClass: String,
        inputClass: String,
        buttonClass: String,
        labelClass: String,
        value: String | Number,
        modelValue: String | Number,
        isRequired: Boolean,
        isDisabled: Boolean,
        isReadonly: Boolean,
        onChange: Function
    },
    emits: ['update:modelValue'],
    data() {
        return {
            newId: _.uuid(),
            newId2: _.uuid()
        };
    },
    mounted() {
        if (this.id && this.id != '') {
            this.newId = this.id;
            this.newId2 = this.id + '_part2';
        }
    },
    computed: {
        viewValue() {
            return this.modelValue ? this.modelValue : this.value;
        },
        viewValue1: {
            get() {
                const val = this.viewValue;
                const vals = val?.split('@');
                if (vals?.length > 0) {
                    return vals[0];
                }
                return '';
            },
            set() {}
        },
        viewValue2: {
            get() {
                const val = this.viewValue;
                const vals = val?.split('@');
                if (vals?.length > 1) {
                    return vals[1];
                }
                return '';
            },
            set() {}
        }
    },
    methods: {
        /**
         * next to input part 2 of zipcode if done part 1
         * -----------------------------------------
         * @author : QuyPN - 2023/07/17 - create
         * @params :
         * @access : private
         */
        netInput(e) {
            if (e.shiftKey && e.keyCode == 50) {
                e.preventDefault();
                this.$refs.input2.focus();
                this.$refs.input2.setSelectionRange(
                    0,
                    this.$refs.input2.value.length
                );
                return false;
            }
            return true;
        },
        /**
         * prev to input part 2 of phone if delete all part 3
         * -----------------------------------------
         * @author : QuyPN - 2023/07/17 - create
         * @params :
         * @access : private
         */
        prevInput(e) {
            if (
                (e.keyCode == 8 || e.keyCode == 46) &&
                e.target.value.length == 0
            ) {
                this.$refs.input1.focus();
            }
        },
        /**
         * check paste zipcode on part 1
         * -----------------------------------------
         * @author : QuyPN - 2023/07/17 - create
         * @params :
         * @access : private
         */
        onPaste1(e) {
            e.preventDefault();
            let value = e.clipboardData.getData('text');
            const vals = value.split('@');
            if (vals.length > 1) {
                this.updateInput(value, e);
            } else {
                this.updateInput(value + '@' + this.viewValue2, e);
            }
        },
        /**
         * check paste zipcode on part 1
         * -----------------------------------------
         * @author : QuyPN - 2023/07/17 - create
         * @params :
         * @access : private
         */
        onPaste2(e) {
            e.preventDefault();
            let value = e.clipboardData.getData('text');
            const vals = value.split('@');
            if (vals.length > 1) {
                this.updateInput(value, e);
            } else {
                this.updateInput(this.viewValue1 + '@' + value, e);
            }
        },
        /**
         * update part 1 of zipcode
         * -----------------------------------------
         * @author : QuyPN - 2023/07/17 - create
         * @params :
         * @access : private
         */
        updateInput1(e) {
            const value = this.$refs.input1.value + '@' + this.viewValue2;
            this.updateInput(value, e);
        },
        /**
         * update part 2 of zipcode
         * -----------------------------------------
         * @author : QuyPN - 2023/07/17 - create
         * @params :
         * @access : private
         */
        updateInput2(e) {
            const value = this.viewValue1 + '@' + this.$refs.input2.value;
            this.updateInput(value, e);
        },
        /**
         * update model of zipcode
         * -----------------------------------------
         * @author : QuyPN - 2023/07/17 - create
         * @params :
         * @access : private
         */
        updateInput(value, e) {
            this.$emit('update:modelValue', value == '@' ? '' : value);
            if (this.onChange) {
                this.onChange(e, value);
            }
        }
    }
};
export default AnsZipCode;
</script>
